/**
 * 前端入口
 * tzw 2022年7月5日20:38:47
 */
import  './fff'
import './sentry'
import  Sentry from './sentry'
import './PCRedirection'
import '@/public/scss/core.scss'
import './customHistory'
// import  './monitor'
import 'promise-polyfill/src/polyfill';


import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { hydrate, render } from 'react-dom'
import { BrowserRouter, useLocation } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
// uri => 页面
import loadable, { loadableReady } from '@loadable/component'
import ErrorBoundary from './ErrorBoundary'
import StoreContext from './context/storeContext'
import store from './store'
import { observer } from '@/hooks/storeHooks'

import MakeRoutes from '@/components/MakeRoutes'
import { CenterToast, cToast, CenterLoading } from '@/components'

import open from '@/page/open'
import core from '@/page/core'
import zhuma_core from '@/page_zhuma/core'
import mock from '@/page/mock'
import zhonghe_core from '@/page_zhonghe/core'
import hotList from '@/page/hotList'
import oneQuestionDay from '@/page/oneQuestionDay'
import courseQuiz from '@/page/courseQuiz'
import my from '@/page/my'
import question_group from '@/page/question_group'
import activity from '@/page/activity'
import caption from '@/page/caption'
import Product from '@/page/product'
import news from '@/page/news'
import teacher from '@/page/teacher'
import questionBank from './page/questionBank'
import searchResult from '@/page/searchResult'
import sem from '@/page/sem'
import productLIst from '@/page/productList'
import integralMall from '@/page/integralMall'
import doExercise from '@/page/doExercise'
import download from '@/page/download'
import mallReconstruction from '@/page/mallReconstruction'
import quiz from '@/page/quiz'
import { verifySendPV } from '@/constants/buryingpoint'
import fff from './page/fff'

import '@/components/LawBook/provision.js'
import { pageGrey } from './utils/pageGrey.js';

import { useStore } from './hooks/storeHooks'

import { Navbar } from '@/components'
import { Topbar as ZmTopbar, Footer as ZmFooter } from '@/components/zhuma'
import { Topbar, Footer, FixBarRight } from '@/components'

import { getUserFirstEnterHome } from '@/utils/buryPoints'




// 竹马和众合公用的路由
const normal_router = Object.assign(
    {},
  fff,
  mock,
    core,
    open,
    oneQuestionDay,
    my,
    hotList,
    question_group,
    caption,
    Product,
    teacher,
    sem,
    productLIst,
    integralMall,
    doExercise,
    mallReconstruction
)
// 众合路由
const zhonghe_router = Object.assign(
    {
        '*': loadable(() => import('./page_zhonghe/core/Home'))
    },
    zhonghe_core,
    normal_router,
    courseQuiz,
    activity,
    news,
    searchResult,
    download,
)

// 竹马路由
const zhumavip_router = Object.assign(
    {
        '*': loadable(() => import('./page_zhuma/core/Home'))
    },
    normal_router,
    zhuma_core,
    courseQuiz,
    activity,
    questionBank,
    quiz
)

const PageManager = observer(function () {
    const { user } = useStore()

    useEffect(() => {
        pageGrey(user).
            then(res => {
            if (res) {
                document.getElementsByTagName('html')[0].style.setProperty('filter', 'grayscale(100%)')
            }
        })
      verifySendPV()
    }, [])


    const { pathname } = useLocation()
    const is_zhuma = window.location.host.indexOf('zhuma') !== -1

    useEffect(()=>{
        if(!store.isZhumavip()) {
            document.getElementsByTagName('body')[0].style.setProperty('--colorStyle','#D1A366')
            document.getElementsByTagName('body')[0].style.setProperty('--colorStyleBg','#FFF5E4')
            document.getElementsByTagName('body')[0].style.setProperty('--colorStyleBgOpacity','rgba(255, 245, 228, 0.5)')
            document.getElementsByTagName('body')[0].style.setProperty('--colorStyleBoder','#E9BA70')
        }
    },[])


    useEffect(() => {
        // 每个页面关闭时移除toast
        return toast.remove()
    }, [pathname])

    useEffect(() => {
        window?.document?.documentElement.setAttribute('data-theme', store.isZhumavip() ? 'zhuma' : 'zhonghe')
    })

    //解决滚动条引起页面的跳动
    useEffect(() => {
        const bodyClassList = document.body.classList;
        const hasScrollClass = bodyClassList.contains('body-scroll');
        if(hasScrollClass || !user.layout?.isPage) {
            bodyClassList.remove('body-scroll')
        }else if (!hasScrollClass) {
            bodyClassList.add('body-scroll')
        }
    }, [user.layout.isPage]);

    useEffect(()=>{
        if (user.businessTypeInfo.businessTypeId) {
            getUserFirstEnterHome()
        }
    },[user.businessTypeInfo])
    useEffect(()=>{
        if (location.hostname.includes('zhongheschool')) {
            getUserFirstEnterHome()
        }
    },[location.hostname])
    return (
        <React.Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>专业法律培训资源提供者----方圆众合教育</title>
                <link rel="icon" href={require(`@/public/images/${store.isZhumavip() ? 'zhuma_favicon.ico' : 'zhonghe_favicon.ico'}`)} sizes="any" />
            </Helmet>
            <Toaster />
            <CenterToast />
            {/* navbar|topbar 移出Page组件 */}
            { user.layout.isPage ? <Navbar /> : null }
            { user.layout.isPage && user.layout.useTopbar ? (store.isZhumavip() ? <ZmTopbar /> : <Topbar />) : null }
            {/* 全局加载动画 */}
            <CenterLoading />
            <MakeRoutes routers={is_zhuma ? zhumavip_router : zhonghe_router} />
        </React.Fragment>
    )
})

// 这是react官方最新推荐的方式，但是存在问题，在热更新下会报错
// 报错原因们目前来看React.Fragment导致的
// if (typeof document !== 'undefined') {
//   // render方式
//   const create_func = process.env.IS_SSR ? hydrateRoot : createRoot
//   const wrap = create_func(document.getElementById('wrap'))

//   const async = process.env.IS_SSR ? loadableReady : (f) => f()

//   async(() => {
//     wrap.render(
//       <ErrorBoundary>
//         <BrowserRouter>
//           <PageManager />
//         </BrowserRouter>
//       </ErrorBoundary>
//     )
//   })
// }



if (typeof document !== 'undefined') {
    // render方式
    const render_func = process.env.IS_SSR ? hydrate : render
    const async = process.env.IS_SSR ? loadableReady : (f) => f()


    async(() => {
        render_func(
            <Sentry.ErrorBoundary>
                <StoreContext.Provider value={store}>
                    <BrowserRouter>
                        <PageManager />
                    </BrowserRouter>
                </StoreContext.Provider>
            </Sentry.ErrorBoundary>,
            document.getElementById('wrap')
        )
    })
}



export default PageManager
